/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.box[_ngcontent-%COMP%]{-ms-flex:0 1 auto;flex:0 1 auto;max-width:100%;overflow-y:auto;max-height:100vh}.box-content[_ngcontent-%COMP%]{width:500px;max-width:100%;padding:48px 24px;text-align:center}.icon[_ngcontent-%COMP%]{opacity:.1}"];
export { styles as styles };
